// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-selectable-article {
  margin: 0 auto;
  flex-grow: 1;
  min-height: 100%;
  word-break: break-word;
  background: white;
  border: 2px solid white;
  border-radius: 5px;
  transition: border 200ms linear;
  text-align: center;
}
.item-selectable-article.selected {
  background: rgba(216, 11, 49, 0.3568627451);
  border: 3px solid var(--ion-color-primary);
}

.option-price {
  font-size: 12px;
  margin-top: auto;
  font-weight: bold;
  color: black;
}

.name {
  margin-top: 12px;
  font-size: 14px;
  width: 100%;
  text-align: center;
  font-family: AppFontBold, sans-serif;
}
@media (max-width: 992px) {
  .name {
    font-size: 12px;
  }
}

p {
  color: var(--ion-color-black);
}

.item-selectable-article-image {
  margin: 0 auto;
  height: 50px;
}

app-quantity-selector {
  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));
}

.quantity-row {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  justify-content: center;
  --quantity-selector-border-width: 1.5px;
  --quantity-selector-height: 24px;
}

.parent {
  background: white;
  border-radius: 5px;
  height: 100%;
}

.vat {
  color: black;
  font-size: 10px;
}

.content-only {
  position: absolute;
  top: 2px;
  right: 4px;
  height: 20px;
  min-height: 20px;
  width: 18px;
  padding: 0;
}

.base-price {
  margin-top: 2px;
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-selectable-article-custom/item-selectable-article-custom.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;AADF;AAEE;EAEE,2CAAA;EACA,0CAAA;AADJ;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAFF;;AAKA;EACE,gBAAA;EACA,eAAA;EAIA,WAAA;EACA,kBAAA;EACA,oCAAA;AALF;ACtBE;EDmBF;IAII,eAAA;EAGF;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,oDAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,uBAAA;EACA,uCAAA;EACA,gCAAA;AACF;;AACA;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;AAEF;;AAAA;EACE,YAAA;EACA,eAAA;AAGF;;AAAA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AAGF;;AAAA;EACE,eAAA;EACA,eAAA;AAGF","sourcesContent":["@import \"../../../theme/mixins\";\n\n.item-selectable-article {\n  margin: 0 auto;\n  flex-grow: 1;\n  min-height: 100%;\n  word-break: break-word;\n  background: white;\n  border: 2px solid white;\n  border-radius: 5px;\n  transition: border 200ms linear;\n  text-align: center;\n  &.selected {\n\n    background: #d80b315b;\n    border: 3px solid var(--ion-color-primary);\n  }\n}\n\n.option-price {\n  font-size: 12px;\n  margin-top: auto;\n  font-weight: bold;\n  color: black;\n}\n\n.name {\n  margin-top: 12px;\n  font-size: 14px;\n  @include mobile {\n    font-size: 12px;\n  }\n  width: 100%;\n  text-align: center;\n  font-family: AppFontBold, sans-serif;\n}\np {\n  color: var(--ion-color-black);\n}\n\n.item-selectable-article-image {\n  margin: 0 auto;\n  height: 50px;\n}\n\napp-quantity-selector {\n  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));\n}\n\n.quantity-row {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  justify-content: center;\n  --quantity-selector-border-width: 1.5px;\n  --quantity-selector-height: 24px;\n}\n.parent {\n  background: white;\n  border-radius: 5px;\n  height: 100%;\n}\n.vat {\n  color: black;\n  font-size: 10px;\n}\n\n.content-only {\n  position: absolute;\n  top: 2px;\n  right: 4px;\n  height: 20px;\n  min-height: 20px;\n  width: 18px;\n  padding: 0;\n}\n\n.base-price {\n  margin-top: 2px;\n  font-size: 10px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
